module.exports = __webpack_public_path__ + "static/media/blastoff-icon.d101a1c0.svg";